/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDobbiesTopPicksCarousel contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum layout {
    carousel = 'carousel',
    grid = 'grid'
}

export interface IDobbiesTopPicksCarouselConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    tiles?: ITilesData[];
    layout?: layout;
    className?: string;
}

export interface IDobbiesTopPicksCarouselResources {
    flipperNext: string;
    flipperPrevious: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface ITilesData {
    image?: Msdyn365.IImageData;
    imageDescription?: string;
    headingText?: string;
    actionLink?: IActionLinkData;
}

export interface IActionLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IDobbiesTopPicksCarouselProps<T> extends Msdyn365.IModule<T> {
    resources: IDobbiesTopPicksCarouselResources;
    config: IDobbiesTopPicksCarouselConfig;
}
